import LayoutFactory from '@/Factories/LayoutFactory';
import { IAsyncElementProvider, IAsyncTupleProvider } from '#/DefaultViewExtensionInterfaces';
import LayoutFactoryTuple from '@/Factories/LayoutFactoryTuple';

export default abstract class AsyncLayoutFactory extends LayoutFactory implements IAsyncElementProvider, IAsyncTupleProvider<LayoutFactoryTuple> {
    public getControl(): JQuery<HTMLElement> {
        throw new Error(`'getControl' is not supported in '${ this.constructor?.name ?? 'AsyncLayoutFactory' }'`);
    }

    public abstract getElementAsync(): Promise<JQuery>;

    public async getTupleAsync(): Promise<LayoutFactoryTuple> {
        if (this.tuple)
            return this.tuple;

        const $element = await this.getElementAsync();
        return new LayoutFactoryTuple(this, $element);
    }
}